<template>
  <div aria-hidden="true"></div>
</template>

<script>
export default {
  name: "FormDivider"
};
</script>

<style lang="scss" scoped>
div {
  @apply block bg-gray-500 h-px max-w-6xl w-full;
}
</style>
